import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { KonditionPopoverPage } from './kondition-popover.page';

const routes: Routes = [
  {
    path: '',
    component: KonditionPopoverPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [KonditionPopoverPage]
})
export class KonditionPopoverPageModule {}
